var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 91,
    height: 91,
    stroke: "url(#paint0_radial_402_291)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0702 25.69C75.0008 26.6088 72.7827 27.2256 70.4508 27.5056C72.8308 26.0794 74.6596 23.8219 75.5171 21.1356C73.2946 22.4525 70.8227 23.4106 68.2021 23.9269C66.1021 21.6869 63.1096 20.2913 59.7977 20.2913C53.4364 20.2913 48.2783 25.445 48.2783 31.8063C48.2783 32.7075 48.3833 33.5869 48.5802 34.4313C39.0077 33.95 30.5246 29.365 24.8414 22.3956C23.8483 24.1019 23.2839 26.0794 23.2839 28.1881C23.2839 32.1825 25.3139 35.7088 28.4071 37.7781C26.5171 37.7169 24.7408 37.1963 23.1877 36.3344C23.1877 36.3825 23.1877 36.4306 23.1877 36.4788C23.1877 42.0613 27.1602 46.7119 32.4233 47.775C31.4608 48.0375 30.4414 48.1775 29.3914 48.1775C28.6477 48.1775 27.9258 48.1075 27.2214 47.9675C28.6914 52.5394 32.9439 55.8775 37.9796 55.9694C34.0421 59.0581 29.0764 60.8956 23.6777 60.8956C22.7458 60.8956 21.8314 60.8431 20.9346 60.7338C26.0271 64.0063 32.0821 65.9094 38.5877 65.9094C59.7714 65.9094 71.3564 48.3613 71.3564 33.145C71.3564 32.6463 71.3433 32.1431 71.3258 31.6531C73.5746 30.03 75.5258 28 77.0702 25.69Z",
    fill: "url(#paint1_linear_402_291)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_402_291",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(50.7106) scale(59.4348 151.238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#F2BB5A",
    stopOpacity: 0.876812
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#BF7A00",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF7A00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1218",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_291",
    x1: 74.5936,
    y1: 63.226,
    x2: 18.9289,
    y2: 30.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#BF841A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(21 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7ead9aaa07327cbd0ea2545ed483f477.svg";
export { ForwardRef as ReactComponent };